export default __webpack_public_path__ + "static/media/icon-see-more.9e37d8c9.svg";